import React, { useState } from "react";
import { CostBlock } from "./styled";
import { QuestionBlock } from "../Question/styled";
import { Container, Heading, Text } from "../../styled";
import Button from "../design_components/Button/Button";
import {
  blackColor,
  blueDarkColor,
  darkColor,
  orangeColor,
} from "../../constants/colors";
import { useHistory } from "react-router";
import { createEventObjectFunction } from "../../utils/helper";
import { loadGenerateEventAmplitude } from "../../amplitude/events";
import { loadGenerateEvent } from "../../firebaseAnalytics/events";
import { analytics } from "../../firebaseAnalytics";
import blueBg from "./../../resources/images/utils/blue.png";
import purpleBg from "./../../resources/images/utils/purple.png";
import ReactPixel from "react-facebook-pixel";
import { useSelector } from "react-redux";

const Cost = ({ data, setUserSum, landingId }) => {
  const [activeSum, setActiveSum] = useState(2);

  const pixelObject = useSelector((state) => state.questions.pixelObject);

  const history = useHistory();

  const handleSumClick = (index) => {
    setActiveSum(index);
  };

  const handleButtonClick = () => {
    setUserSum(data.answers[activeSum].value);
    const eventObj = createEventObjectFunction(null, null, landingId);
    eventObj.price = data.answers[activeSum].value;
    // Событие №7 load generate
    const pixelobj = {
      value: data.answers[activeSum].value,
      currency: "USD",
    };
    ReactPixel.track("StartTrial", pixelobj);
    loadGenerateEvent(analytics, eventObj);
    loadGenerateEventAmplitude(eventObj);
    history.push(data.nextRoute);
  };

  const answersRender = () => {
    return data.answers.map((answer, index) => {
      return (
        <CostBlock.Answers.Item
          key={`cost-${index}`}
          onClick={() => handleSumClick(index)}
        >
          <CostBlock.Answers.Item.Top
            className={index === activeSum ? "active" : null}
          >
            <Heading.Fifth color={blackColor}>{answer.sum}</Heading.Fifth>
          </CostBlock.Answers.Item.Top>
          {answer.text ? (
            <CostBlock.Answers.Item.Text
              className={index === activeSum ? "active" : null}
            >
              <Text.Seventh>{answer.text}</Text.Seventh>
            </CostBlock.Answers.Item.Text>
          ) : null}
        </CostBlock.Answers.Item>
      );
    });
  };

  return (
    <CostBlock>
      <img className="blue" src={blueBg} alt="bg" />
      <img className="purple" src={purpleBg} alt="bg" />
      <CostBlock.Wrapper>
        <CostBlock.Top>
          <Container.Content>
            <Heading.Third
              style={{
                textAlign: "left",
                marginBottom: 12,
              }}
            >
              {data.title}
            </Heading.Third>
            {data.text.map((text, index) => {
              return (
                <Text.Fourth style={{ marginBottom: 13, textAlign: "left" }}>
                  {" "}
                  {text}
                </Text.Fourth>
              );
            })}
          </Container.Content>
        </CostBlock.Top>
        <CostBlock.Bottom>
          <Container.Content>
            <CostBlock.Bottom.Content>
              <CostBlock.Bottom.Content.Top>
                <Heading.Third
                  style={{
                    textAlign: "left",
                    marginBottom: 32,
                  }}
                >
                  Choose a price for your 7-day trial
                </Heading.Third>
                <CostBlock.Answers>{answersRender()}</CostBlock.Answers>
              </CostBlock.Bottom.Content.Top>
              <CostBlock.Bottom.Content.Bottom>
                <Text.Fourth
                  style={{
                    textAlign: "center",
                    marginBottom: 20,
                    color: blueDarkColor,
                    opacity: 0.7,
                  }}
                >
                  Your trial fee will directly support our sleep experts &
                  non-profit partners.
                </Text.Fourth>
                <Button
                  isGradient={true}
                  type={"default"}
                  text={"Continue"}
                  action={() => handleButtonClick()}
                  disabled={activeSum === null}
                />
              </CostBlock.Bottom.Content.Bottom>
            </CostBlock.Bottom.Content>
          </Container.Content>
        </CostBlock.Bottom>
      </CostBlock.Wrapper>
    </CostBlock>
  );
};

export default Cost;
